import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

export function IconLocation(props: Props) {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82887 3.7379C9.23708 0.208582 14.7629 0.208582 18.1711 3.7379C21.5793 7.26722 21.5793 12.9894 18.1711 16.5186L12 22.9091L5.82887 16.5186C2.42065 12.9894 2.42065 7.26722 5.82887 3.7379ZM12 12.7104C13.3772 12.7104 14.4935 11.5544 14.4935 10.1283C14.4935 8.70224 13.3772 7.54619 12 7.54619C10.6229 7.54619 9.50648 8.70224 9.50648 10.1283C9.50648 11.5544 10.6229 12.7104 12 12.7104Z"
        fill="#f97316"
      />
    </svg>
  );
}
